export const NOTIFICATION_TYPES = {
    SUCCESS: 1,
    INFO: 2,
    WARNING: 3,
    ERROR: 4,
    ACTION: 5,
}

export const NOTIFICATION_ACTIONS = {
    MBA_UPGRADE: 'mba_upgrade',
    ZIP_EXPORT_READY: 'zip_export_ready',
}
